import React from "react";
import PropTypes from "prop-types";
import { formatDate } from "utils/dates";

const formatLog = ({ column, old_value, new_value }) => {
  return `${column} Changed from ${
    old_value && old_value.trim() ? old_value : "<BLANK>"
  } to ${new_value && new_value.trim() ? new_value : "<BLANK>"}`;
};

const TaskLogs = ({ logs }) => {
  return (
    <div style={{ padding: 10 }}>
      <h3>Logs</h3>
      <table
        style={{
          width: "100%"
        }}
      >
        <thead>
          <tr>
            <th>Time</th>
            <th>User</th>
            <th>Changes</th>
          </tr>
        </thead>
        <tbody>
          {logs.map(x => (
            <tr key={x.id}>
              <td>{formatDate(x.timestamp, "MMM DD, YYYY hh:mm A")}</td>
              <td>{x.changed_by}</td>
              <td>{formatLog(x)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

TaskLogs.propTypes = { logs: PropTypes.arrayOf(PropTypes.object).isRequired };

export default TaskLogs;
